<div class="inner">
  <div class="info">
    <h1 class="title">{{ title() }}</h1>
    @if (showCallDetails()) {
      <button qai-link class="view-call-details-link" (click)="handleViewCallDetailsClick()">
        {{ 'learningPathway.VIEW_CALL_DETAILS' | transloco }}
      </button>
      <app-practice-call-details-modal
        [title]="title()"
        [callDetails]="callDetails()"
        (modalOpened)="callDetailsModalOpened.emit()"
        (modalClosed)="callDetailsModalClosed.emit()"
      />
    }
  </div>

  <div class="settings">
    <button
        qai-icon-button
        [icon]="'settings'"
        [kind]="'primary-default'"
        [size]="'24px'"
        (click)="handleSettingsClick()"
        >
        {{ 'learningPathway.SETTINGS' | transloco }}
     </button>

     <button
        qai-icon-button
        [icon]="'x-close'"
        [kind]="'primary-default'"
        [size]="'24px'"
        (click)="handleLeaveStepClick()"
        >
        {{ 'learningPathway.LEAVE_STEP' | transloco }}
     </button>
  </div>
</div>
